import Vue from "vue";
import { i18n } from "../i18n";

export function regex(exp: RegExp, messageKey: string) {
  return (v: string) => {
    return !v || exp.test(v) || i18n.t(messageKey);
  };
}

export function maxLength(value: number, messageKey?: string) {
  return (v: string) => {
    return (!v || (v && v.length <= value)) || i18n.t(messageKey || "validation.maxLength",{value});
  };
}

export function required(messageKey?: string) {
  return (v: string) => {
    return !!(v || "").toString().trim() || i18n.t(messageKey || "validation.required");
  };
}

Vue.use({
  install(/* vue, options = {} */) {
    Vue.prototype.$validation = { regex, required , maxLength};
  },
});

declare module "vue/types/vue" {
  interface Vue {
    $validation: {
      regex: (exp: RegExp, messageKey: string) => (value: string) => boolean | string;
      required: (messageKey?: string) => (value: string) => boolean | string;
      maxLength: (value: number, messageKey?: string) => boolean | string;
    };
  }
}
